import { getUserState, UserStore } from "../../../../store";
import { fetchMeThunk } from "../../../../store/getMe";

export function delayedApiDispatch() {
  setTimeout(() => {
    if (getUserState().dataStatus == "notInitiated") {
      UserStore.dispatch(fetchMeThunk());
    }
  }, 5);
}
